// extracted by mini-css-extract-plugin
export var advance__title = "style-module--advance__title--c9cf1";